<form [formGroup]="form" class="form" *ngIf="formReady">
  <div class="form-body">

    <div class="form-section" [ngClass]="{ 'form-section_detailed': displayMoreDetails }">
      <ng-container *ngIf="!isManufacturer">
        <app-form-row [label]="'FORMS.CUSTOMER.BASIC_INFO.CUSTOMER_NUMBER' | translateControl : form | async">
          <app-input [type]="'text'" [mainForm]="form" [controlName]="'customerNumber'" datatestid="customerNumberInput"></app-input>
        </app-form-row>
      </ng-container>

      <app-form-row [label]="'FORMS.CUSTOMER.BASIC_INFO.ASSOCIATION' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'association'"></app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.CUSTOMER.BASIC_INFO.SHAREHOLDER_NR' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'shareholderId'"></app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.CUSTOMER.BASIC_INFO.NAME' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'name'" datatestid="companyNameInput"></app-input>
        <ng-container *ngIf="canUpdateCustomer && !additionalNames.controls.length">
          <ng-template [ngTemplateOutlet]="AddAdditionalName"></ng-template>
        </ng-container>
      </app-form-row>

      <ng-container *ngFor="let additionalName of additionalNames.controls; let i = index">
        <app-form-row [label]="'FORMS.CUSTOMER.BASIC_INFO.ADDITIONAL_NAME' | translateControl : form | async">
          <div class="d-flex">
            <app-input class="flex-grow-1" [type]="'text'" [mainForm]="additionalName" [controlName]="'name'"
              [autoFocus]="focusNewAdditionalName && i === additionalNames.controls.length - 1">
            </app-input>
            <button type="button" class="btn btn_link btn_icon btn_delete" (click)="removeAdditionalName(i)" svgIcon
              [icon]="'delete'">
            </button>
          </div>
          <ng-container *ngIf="canUpdateCustomer && i === additionalNames.controls.length - 1">
            <ng-template [ngTemplateOutlet]="AddAdditionalName"></ng-template>
          </ng-container>
        </app-form-row>
      </ng-container>

      <ng-container *ngFor="let address of addresses.controls; let i = index">
        <app-form-row
          [label]="['FORMS.ADDRESS.STREET_NAME', 'FORMS.ADDRESS.STREET_NR'] | translateControl : address | async">
          <div class="row">
            <div class="col-8">
              <app-input [type]="'text'" [mainForm]="address" [controlName]="'streetName'"></app-input>
            </div>
            <div class="col-4">
              <app-input [type]="'text'" [mainForm]="address" [controlName]="'streetNr'"></app-input>
            </div>
          </div>
        </app-form-row>

        <app-form-row
          [label]="['FORMS.ADDRESS.ZIP_CODE', 'FORMS.ADDRESS.CITY', 'FORMS.ADDRESS.COUNTRY'] | translateControl : address | async">
          <div class="row">
            <div class="col-3">
              <app-input [type]="'text'" [mainForm]="address" [controlName]="'zipCode'" datatestid="zipCodeInput"></app-input>
            </div>
            <div class="col-5">
              <app-input [type]="'text'" [mainForm]="address" [controlName]="'city'"></app-input>
            </div>
            <div class="col-4">
              <app-dropdown [options]="dropdownData.countries" [labelKey]="'title'" [valueKey]="'value'"
                [mainForm]="address" [controlName]="'country'" [searchable]="true" [defaultValue]="dropdownData.countries[0].value">
              </app-dropdown>
            </div>
          </div>
        </app-form-row>
      </ng-container>

      <app-form-row [label]="'FORMS.COMMON.EMAIL' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'email'"></app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.COMMON.PHONE' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'phone'"></app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.COMMON.FAX' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'fax'"></app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.COMMON.WEBSITE' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'website'"></app-input>
      </app-form-row>
    </div>

    <div class="form-section" [ngClass]="{ 'form-section_detailed': displayMoreDetails }">
      <div class="collapseArea">

        <div *ngIf="!displayMoreDetails" class="collapseArea-trigger" aria-controls="collapseBasic"
          (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
          [ngClass]="{'collapseArea-trigger_open': !isCollapsed}">
          <i svgIcon [icon]="'arrow'" [ngClass]="{'_open': !isCollapsed}"></i>
          {{'FORMS.CUSTOMER.BASIC_INFO.MORE_DETAILS' | translate}}
        </div>
        <div [collapse]="isCollapsed" [isAnimated]="true">
          <div class="collapseArea-body">
            <app-form-row [label]="'FORMS.CUSTOMER.BASIC_INFO.DELIVERY_TERMS' | translateControl : form | async">
              <app-textarea [mainForm]="form" [controlName]="'deliveryTerms'"></app-textarea>
            </app-form-row>
            <app-form-row [label]="'FORMS.CUSTOMER.BASIC_INFO.EXTERNAL_SALES' | translateControl : form | async">
              <app-input [type]="'text'" [mainForm]="form" [controlName]="'externalSales'"></app-input>
            </app-form-row>
            <app-form-row [label]="'FORMS.CUSTOMER.BASIC_INFO.INTERNAL_SALES' | translateControl : form | async">
              <app-input [type]="'text'" [mainForm]="form" [controlName]="'internalSales'"></app-input>
            </app-form-row>
            <app-form-row [label]="'FORMS.CUSTOMER.BASIC_INFO.INFORMATION' | translateControl : form | async">
              <app-textarea [mainForm]="form" [controlName]="'information'"></app-textarea>
            </app-form-row>
            <ng-container *ngIf="!isManufacturer">
              <app-form-row [label]="'FORMS.CUSTOMER.BASIC_INFO.PAYMENT_CONDITIONS' | translateControl : form | async">
                <app-textarea [mainForm]="form" [controlName]="'paymentConditions'"></app-textarea>
              </app-form-row>
              <app-form-row [label]="'FORMS.CUSTOMER.BASIC_INFO.TAX_ID' | translateControl : form | async">
                <app-input [type]="'text'" [mainForm]="form" [controlName]="'taxId'"></app-input>
              </app-form-row>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<ng-template #AddAdditionalName>
  <div class="form-controlAction">
    <button type="button" class="btn btn_link btn_icon" (click)="addAdditionalName()" svgIcon [icon]="'plus'"
      [disabled]="additionalNames.controls.length >= MAX_ADDITIONAL_NAMES"
      [tooltip]="additionalNames.controls.length >= MAX_ADDITIONAL_NAMES
        ? ('FORMS.CUSTOMER.BASIC_INFO.MAX_3_ADDITIONAL_NAMES' | translate)
        : null">
      {{ 'FORMS.CUSTOMER.BASIC_INFO.ADDITIONAL_NAME' | translate }}
    </button>
  </div>
</ng-template>
